export const episodeCovers = [
  {
    image: 'https://media-manager-c.questera.ai/greta-media/8210ad95efb747bb311b069cf26456dbc6f4698f846d83a8cc9125e272c4df314dbaa665e28d14a7414479ed5b72910d/images/aW1hZ2Uvd2VicA==/426b55726170dd622fe26f3a72078517.webp',
    alt: 'Episode cover featuring a speaker and the words “Reflect” and “Human-Centered AI”.'
  },
  {
    image: 'https://media-manager-c.questera.ai/greta-media/8210ad95efb747bb311b069cf26456dbc6f4698f846d83a8cc9125e272c4df314dbaa665e28d14a7414479ed5b72910d/images/aW1hZ2Uvd2VicA==/e9ce1e29c876dd30e901b7120e7ad57d.webp',
    alt: 'Episode cover featuring a speaker, circuit imagery, and the words “AI’s Next Big Leap”.'
  },
  {
    image: 'https://media-manager-c.questera.ai/greta-media/8210ad95efb747bb311b069cf26456dbc6f4698f846d83a8cc9125e272c4df314dbaa665e28d14a7414479ed5b72910d/images/aW1hZ2Uvd2VicA==/79e054dc9a9ab493f95d8fe84e7c5b21.webp',
    alt: 'Episode cover featuring a speaker wearing a headset, a gold number one, and the words “Become Category One”.'
  },
  {
    image: 'https://media-manager-c.questera.ai/greta-media/8210ad95efb747bb311b069cf26456dbc6f4698f846d83a8cc9125e272c4df314dbaa665e28d14a7414479ed5b72910d/images/aW1hZ2Uvd2VicA==/9652d46104c8d1aeedc0ed3590d739d3.webp',
    alt: 'Episode cover featuring three speakers and the words “AI Efficiency Explained”.'
  },
  {
    image: 'https://media-manager-c.questera.ai/greta-media/8210ad95efb747bb311b069cf26456dbc6f4698f846d83a8cc9125e272c4df314dbaa665e28d14a7414479ed5b72910d/images/aW1hZ2Uvd2VicA==/1687bcba2e71af3fd5bae36106021429.webp',
    alt: 'Episode cover featuring a speaker with a microphone, privacy-themed illustrations, and the words “Why I built it bare”.'
  }
];

export const watchUrl = 'https://territory.digitalcowboy.io/en/blog';